'use strict';

exports.init = function () {
    // window.JsBarcode('#code128').init();
    window.JsBarcode('.barcode').init();
};
